import React from "react";
import i18n from "i18next";
import { useTheme } from "@/lib/theme";
import { Sun, Moon } from "lucide-react";

/**
 * Theme toggle — segmented Sun/Moon control with sliding pill.
 * Drop anywhere in the chrome. Compact, accessible, no layout shifts.
 */
export default function ThemeToggle({ className = "" }) {
    const { theme, toggle } = useTheme();
    const isLight = theme === "light";
    return (
        <button type="button"
            onClick={toggle}
            role="switch"
            aria-checked={isLight}
            aria-label={isLight ? i18n.t("theme.to_dark") : i18n.t("theme.to_light")}
            title={isLight ? i18n.t("theme.to_dark") : i18n.t("theme.to_light")}
            data-testid="theme-toggle"
            className={`relative inline-flex items-center w-14 h-7 rounded-full border transition-colors ${className}`}
            style={{
                background: isLight ? "rgba(15,17,21,0.05)" : "rgba(255,255,255,0.05)",
                borderColor: "var(--jr-border)",
            }}>
            {/* Sliding pill */}
            <span aria-hidden
                className="absolute top-0.5 left-0.5 w-6 h-6 rounded-full transition-transform"
                style={{
                    background: "var(--jr-brand)",
                    transform: isLight ? "translateX(28px)" : "translateX(0)",
                    boxShadow: "0 2px 8px -2px rgba(0,0,0,0.35)",
                }} />
            {/* Icons */}
            <span className="absolute inset-0 flex items-center justify-between px-1.5 pointer-events-none">
                <Moon size={12} style={{ color: isLight ? "var(--jr-text-3)" : "var(--jr-text-invert)" }} />
                <Sun size={12} style={{ color: isLight ? "var(--jr-text-invert)" : "var(--jr-text-3)" }} />
            </span>
        </button>
    );
}
